module.exports = __webpack_public_path__ + "static/media/minirobo.de26b4ed.mp4";